import React from "react";
import { useTranslation } from "react-i18next";
import "./css/solutions.css";
import paperHero from "./img/paper1.webp";
import { ensureNamespace } from "../../i18n/ensurePageI18n";

const loadI18n = (i18n) => {
  ensureNamespace(i18n, 'paper', {
    en: {
      sectionTitle: "Paper",
      sectionSubtitle: "Automated Web Inspection for Paper Surface Quality",
      title: "PAPER",
      heroDesc: "Wintriss Engineering automated web inspection systems accurately classify and evaluate defects based on multiple image features including size, shape and gray value.",
      typicalProductsTitle: "Typical Products",
      typicalProductsContent: "Commercial printing papers, converting papers, digital papers, office papers, coated papers and specialty papers.",
      typicalDefectsTitle: "Typical Defects",
      typicalDefectsContent: "Pinholes, bugs, black spots, scratches, creases, rough edges, missing coatings, strips, bright spots."
    },
    zh: {
      sectionTitle: "紙張",
      sectionSubtitle: "紙張表面品質自動化網狀檢測",
      title: "紙張",
      heroDesc: "微覺視自動化網頁檢測系統可依尺寸、形狀與灰階值等多重影像特徵精準分類與評估缺陷。",
      typicalProductsTitle: "典型產品",
      typicalProductsContent: "商業印刷紙、加工用紙、數位用紙、辦公用紙、塗佈紙、特殊紙。",
      typicalDefectsTitle: "常見缺陷",
      typicalDefectsContent: "針孔、蟲斑、黑點、刮傷、摺痕、毛邊、缺塗佈、條紋、亮點。"
    }
  });
};

function Paper() {
  const { t, i18n } = useTranslation();
  loadI18n(i18n);

  return (
    <div>
      <section className="section-paper relative bg-gray-900 text-white">
        <div className="absolute inset-0 bg-black bg-opacity-70" />
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-5xl font-bold mb-4">{t("paper:sectionTitle")}</h1>
          <p className="text-xl text-white">{t("paper:sectionSubtitle")}</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="text-3xl font-bold mb-4 tracking-wide">{t("paper:title")}</h2>
          <p className="leading-relaxed text-sm md:text-base">{t("paper:heroDesc")}</p>
        </div>
        <div className="flex justify-center">
          <img src={paperHero} alt={t("paper:title")} className="rounded-lg shadow-lg w-full max-w-md object-cover" loading="lazy" />
        </div>
      </div>

      <section className="max-w-7xl mx-auto px-6 pb-20 grid md:grid-cols-2 gap-6">
        <div className="bg-white border rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">{t("paper:typicalProductsTitle")}</h3>
          <p className="text-sm text-gray-700 leading-relaxed">{t("paper:typicalProductsContent")}</p>
        </div>
        <div className="bg-white border rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3">{t("paper:typicalDefectsTitle")}</h3>
          <p className="text-sm text-gray-700 leading-relaxed">{t("paper:typicalDefectsContent")}</p>
        </div>
      </section>
    </div>
  );
}

export default Paper;